import axios from "axios";
import React, { Component } from "react";
import AppConfig from "../../config/AppConfig";
import Info1 from "./info/Info";
import Profile1 from "./profile/Profile1";
class Profile extends Component {
  state = {
    data: [],
    loading: true,
  };
  componentDidMount() {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      if (this.props.id_sp !== undefined) {
        session = "/" + this.props.id_sp;
      } else {
        session = "/" + sessiondata.i_idunit;
      }
    }
    let data = AppConfig.Profile + session;
    let rq = axios.get(data);
    axios
      .all([rq])
      .then(
        axios.spread((...responses) => {
          let response = responses[0];
          let data_profile = {
            data: response.data.result,
          };
          this.setState(
            {
              data: data_profile,
              loading: false,
            },
            () => {
              console.log(this.state.data);
            }
          );
        })
      )
      .catch((errors) => {
        console.log(errors);
      });
  }
  render() {
    // console.log("DATA ===", this.state.data)
    return (
      <>
        <Info1 dataProfile={this.state.data} displayData={this.state.loading} />
        <br />
        <Profile1
          dataProfile={this.state.data}
          displayData={this.state.loading}
        />
      </>
    );
  }
}
export default Profile;
